import {Store} from '../classes/store';
import {Injectable} from '@angular/core';
import {ApiLegacyService} from '../../../services/api/api.service';
import {Building} from '../../../resources/building/building.interface';

@Injectable({
  providedIn: 'root'
})
export class BuildingStore extends Store<Building> {

  /** Constructor. */
  constructor( ) {
    super();
  }

}
